import { render, staticRenderFns } from "./step-upload-imagem.vue?vue&type=template&id=77650123&"
import script from "./step-upload-imagem.vue?vue&type=script&lang=js&"
export * from "./step-upload-imagem.vue?vue&type=script&lang=js&"
import style0 from "./step-upload-imagem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports